/* eslint-disable @typescript-eslint/no-unused-vars */
import { removeCookie, getCookie } from './cookie';
import { SwalAlert } from 'common/Swal/swal.common';
import { postRefreshToken } from 'api/login';
import { parseJWT } from 'helper/jwt';

export const handleError = async (dataArray?: any, header?: string, title?: string) => {
  const { data, status } = dataArray;
  const lang = getCookie('lang');
  let headerText = '';
  if (lang === 'th') {
    headerText = 'ขออภัยคุณไม่มีสิทธิ์เข้าถึง หรือ Token ของท่านหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง';
  } else {
    headerText = 'Sorry, you don`t have access or your token has expired. Please log in again.';
  }
  if (status) {
    if (status === 403) {
      SwalAlert({
        icon: '',
        svgIcon: '403',
        header: header || headerText,
        title: title || '',
        timer: 4000,
        showConfirmButton: false,
        confirmButtonText: '',
        showCloseButton: false,
        cancelButtonText: '',
        showCancelButton: false,
        reverseButtons: true,
        willClose: () => {
          window.location.assign('/');
        },
      });
      removeCookie('access_token_backoffice');
      removeCookie('dataUserToken');
      removeCookie('dataUserAll');
      removeCookie('role');
      removeCookie('role_id');
      removeCookie('sessionId');
      setTimeout(() => {
        window.location.assign('/');
      }, 4000);
    } else if (status === 401) {
      const refreshTokenData: any = getCookie('refresh_tokenltl');
      const parsedJwt = parseJWT(refreshTokenData);
      const params = {
        username: parsedJwt.username,
        refreshtoken: refreshTokenData,
      };
      const responseData = await postRefreshToken({ params: params });
      removeCookie('access_tokenltl');
      removeCookie('refresh_tokenltl');
      removeCookie('expires_tokenltl');
      removeCookie('dataUser');
      removeCookie('sessionId');
      localStorage.clear();
      window.location.assign('/');
      return responseData;
    } else if (status === 404 || data === 'DATA_NOT_FOUND') {
      return false;
    } else if (status === 400) {
      SwalAlert({
        icon: '',
        svgIcon: 'warning',
        header: data?.message ? data?.message : header || headerText,
        title: title || '',
        timer: 4000,
        showConfirmButton: false,
        confirmButtonText: '',
        showCloseButton: false,
        cancelButtonText: '',
        showCancelButton: false,
        reverseButtons: true,
        // willClose: () => {
        //   window.location.assign('/');
        // }
      });
    }
  }
};
